var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 10,
    viewBox: "0 0 4 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.92969 9.17188C1.61719 9.17188 1.35156 9.07031 1.13281 8.86719C0.914062 8.65885 0.804688 8.41146 0.804688 8.125C0.804688 7.83333 0.914062 7.58333 1.13281 7.375C1.35156 7.16667 1.61719 7.0625 1.92969 7.0625C2.2474 7.0625 2.51562 7.16667 2.73438 7.375C2.95833 7.58333 3.07031 7.83333 3.07031 8.125C3.07031 8.41146 2.95833 8.65885 2.73438 8.86719C2.51562 9.07031 2.2474 9.17188 1.92969 9.17188ZM1.92969 2.99219C1.61719 2.99219 1.35156 2.89062 1.13281 2.6875C0.914062 2.47917 0.804688 2.23177 0.804688 1.94531C0.804688 1.65365 0.914062 1.40365 1.13281 1.19531C1.35156 0.986979 1.61719 0.882812 1.92969 0.882812C2.2474 0.882812 2.51562 0.986979 2.73438 1.19531C2.95833 1.40365 3.07031 1.65365 3.07031 1.94531C3.07031 2.23177 2.95833 2.47917 2.73438 2.6875C2.51562 2.89062 2.2474 2.99219 1.92969 2.99219Z",
    fill: "#16304F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColonIcon);
export default __webpack_public_path__ + "static/media/colon-icon.11e64c01218a08848b7a9f46a7e82675.svg";
export { ForwardRef as ReactComponent };